// @flow
import _ from 'lodash/fp';
import React, {Component} from 'react';
import background from '../../assets/bg.jpg';
import './Login.css';
import logo from '../../assets/logo.png';

export type Props = {
  onLoginClick: Function,
};

class Login extends Component<Props> {
  props: Props;
  _username: any;
  _password: any;

  render() {
    return (
      <div className="Login">
        <div
          className="Login-background"
          style={({
            backgroundImage: `url('${background}')`,
          })}></div>
        <div className="row align-center">
          <div className="column">
            <img
              src={logo}
              className="Login-logo"
              alt="logo" />
            <h1>dina tillval</h1>
            <h2>personliga val - för din smakfulla nya bostad</h2>
            <p>
              Välkommen till dina tillval!
            </p>
            <div className="row align-center">
              <form
                role="form"
                className="Login-form column shrink"
                onSubmit={e => this.login(e)}>
                <input
                  type="text"
                  ref={ref => this._username = ref}
                  name="username"
                  placeholder="Användarnamn"
                  required />
                <input
                  type="password"
                  ref={ref => this._password = ref}
                  name="password"
                  placeholder="Lösenord"
                  required />
                <button
                  className="button expanded"
                  type="submit">
                  Logga in
                </button>
                <span className="Login-text">
                  Inget konto - <a href="mailto:anki.hagstrom@hokerumbygg.se">kontakta våra säljare.</a>
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  login(e: Event) {
    e.preventDefault();

    if (this._username && this._password) {
      const username = _.trim(this._username.value);
      const password = this._password.value;
      this.props.onLoginClick(username, password);
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js